export default "__VITE_ASSET__f8b676ad__"